
<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'Home',

    metaInfo: { title: 'Início' },

    extends: View,

    mixins: [
      LoadSections([
        'hero',
        'about-us',
        'features',
        'theme-features',
        'contact-us',
        // 'pro-features',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'home',
      },
    },
  }
</script>
